import React, { useState, useEffect } from 'react';
import {
  ErrorMessage,
  LoadingMessage,
  Markdown,
  Image,
  Utils,
  C,
} from '@kineticdata/bundle-common';
import { I18n, fetchSubmission } from '@kineticdata/react';
import { PageTitle } from '../shared/PageTitle';

export const NewsArticle = ({
  match: {
    params: { id },
  },
}) => {
  const [submission, setSubmission] = useState(null);
  const [error, setError] = useState(null);

  const backgroundImage =
    submission &&
    (submission.values['Image'] ||
      Utils.getAttributeValue(submission.form || {}, 'Image'));

  useEffect(
    () => {
      if (id) {
        fetchSubmission({
          id,
          include: 'values,form,form.attributes[Image]',
        }).then(({ submission, error }) => {
          if (submission && submission.form.slug === C.FORM_SLUG_NEWS) {
            setSubmission(submission);
          } else {
            setError(error || { message: 'Unexpected error occurred.' });
          }
        });
      } else {
        setError({ message: 'Missing article id.' });
      }
    },
    [id],
  );

  return (
    <div className="page-container">
      {submission && (
        <div className="page-image">
          {backgroundImage && <Image src={backgroundImage} alt="" />}
        </div>
      )}
      <div className="page-panel">
        <PageTitle
          className="page-title-heading--sm"
          parts={[submission && submission.values['Title'], 'Latest News']}
          title={submission && submission.values['Title']}
          subtitle={submission && submission.values['Description']}
          breadcrumbs={[
            {
              label: (
                <span>
                  <span className="fa fa-fw fa-md fa-arrow-left text-muted" />
                  <I18n>Latest News</I18n>
                </span>
              ),
              to: '/news',
            },
          ]}
        />

        {error ? (
          <ErrorMessage message={error.message} />
        ) : !submission ? (
          <LoadingMessage />
        ) : submission.values['News Article Type'] === 'Content' ? (
          <Markdown
            initialValue={submission.values['Content']}
            disabled={true}
          />
        ) : !!submission.values['Link'] ? (
          <button className="btn btn btn-outline-dark btn-animate">
            <I18n>{submission.values['Link Label'] || 'Read More'}</I18n>
            <span className="fa fa-arrow-right" />
          </button>
        ) : null}
      </div>
    </div>
  );
};
